<template>
  <v-container fluid style="padding-right:0px; padding-bottom:0px">
    <local-events-helpers :data="cleanEventData" :hotRef="hotRef" />
    <v-row no-gutters>
      <v-col>
        <div class="hot">
          <hot-table :data="cleanEventData" :settings="hotSettings" ref="hotTableComponent" id="events-table" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { HotTable } from '@handsontable/vue'
  import Handsontable from 'handsontable'
  import LocalEventsHelpers from './LocalEventsHelpers'
  import moment from 'moment'
  import {
    normalizeMobilizeData,
    eventURLRenderer,
    adPreviewRenderer,
    mapPreviewRenderer
  } from '../../../helpers/functions'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'LocalEvents',
    components: {
      HotTable,
      LocalEventsHelpers
    },
    data () {
      return {
        hotRef: {}
      }
    },
    computed: {
      cleanEventData () {
        return normalizeMobilizeData(this.rawEventData)
      },
      ...mapState({
        rawEventData: state => state.mobilize.mobilize
      }),
      ...mapGetters([
        'getAudiencesNames'
      ]),
      hotSettings () {
        return {
          licenseKey: 'non-commercial-and-evaluation',
          nestedHeaders: [
            [
              {label: '', colspan: 4},
              {label: 'Ad content', colspan: 4},
              {label: 'Event details', colspan: 8},
              {label: 'Ad targeting', colspan: 7}
            ],
            ['Select', 'Event', 'Ad?', 'Image', 'Ad text', 'Headline', 'Link description', 'Preview', 'Event type', 'Venue', 'Address', 'City', 'State', 'Zip', 'Event URL', 'Sponsor Org', 'Audience', 'Geo target', 'Map', 'Start', 'Start time', 'End', 'End time', 'Budget']],
          columns: [
            {
              data: '',
              type: 'checkbox',
              className: "htCenter"
            },
            {
              data: 'event_id',
              readOnly: true,
              renderer: eventURLRenderer
            },
            {
              data: 'ad_exists',
              type: 'checkbox',
              className: "htCenter",
              readOnly: true
            },
            {
              data: 'image_url',
              renderer: (instance, td, row, col, prop, value, cellProperties) => {
                let img = document.createElement('IMG')
                img.src = value
                Handsontable.dom.addEvent(img, 'mousedown', function (event) {
                  event.preventDefault()
                })
                Handsontable.dom.empty(td)
                td.appendChild(img)
                return td
              }
            },
            {
              data: 'ad_text'
            },
            {
              data: 'ad_headline'
            },
            {
              data: 'ad_link_description'
            },
            {
              readOnly: true,
              renderer: adPreviewRenderer
            },
            {
              data: 'event_type',
              readOnly: true
            },
            {
              data: 'location_venue',
              readOnly: true
            },
            {
              data: 'location_address',
              readOnly: true
            },
            {
              data: 'location_locality',
              readOnly: true
            },
            {
              data: 'location_region',
              readOnly: true
            },
            {
              data: 'location_postal_code',
              readOnly: true
            },
            {
              data: 'browser_url',
              readOnly: true
            },
            {
              data: 'sponsor_name',
              readOnly: true
            },
            {
              data: 'audience',
              type: 'dropdown',
              strict: true,
              // source: this.getAudiencesNames
              source: ['Email_Grass_2021', 'Email_HV_2021', 'Previous volunteers', 'Volunteers 1% LAL', 'Volunteers 2% LAL', 'Volunteers 3% LAL', 'Volunteers 5% LAL', 'Website 7 days', 'Website 30 days']
            },
            {
              data: 'geo_target',
              type: 'autocomplete',
              source: ['National', 'Same state', 'Same CD', 'Same city', 'Same zip', '+1 mi', '+2 mi', '+3 mi', '+4 mi', '+5 mi', '+10 mi', '+15 mi', '+20 mi', '+25 mi', '+40 mi']
            },
            {
              readOnly: true,
              renderer: mapPreviewRenderer
            },
            {
              data: 'start_date',
              type: 'date',
              dateFormat: 'MMM D',
              correctFormat: true,
              defaultDate: moment().format('MMM D'),
              // datePicker additional options (see https://github.com/dbushell/Pikaday#configuration)
              datePickerConfig: {
                // First day of the week (0: Sunday, 1: Monday, etc)
                firstDay: 1
              }
            },
            {
              data: 'start_time',
              type: 'time',
              timeFormat: 'h:mm A',
              correctFormat: true
            },
            {
              data: 'end_date',
              type: 'date',
              dateFormat: 'MMM D',
              correctFormat: true,
              defaultDate: moment().format('MMM D'),
              // datePicker additional options (see https://github.com/dbushell/Pikaday#configuration)
              datePickerConfig: {
                // First day of the week (0: Sunday, 1: Monday, etc)
                firstDay: 1
              }
            },
            {
              data: 'end_time',
              type: 'autocomplete',
              strict: true,
              source: ['9AM day before', '8PM day before', '9AM day of']
            },
            {
              data: 'budget',
              type: 'numeric',
              numericFormat: {
                pattern: '$0,0',
                culture: 'en-US'
              }
            }
          ],
          rowHeaders: true,
          width: '100%',
          colWidths: 90,
          fixedColumnsLeft: 4,
          cells: function (row, col) {
            let cellProperties = {}

            if (col === 0) {
              cellProperties.colWidths = 60
            } else if (col === 1) {
              cellProperties.colWidths = 80
            } else if (col === 2) {
              cellProperties.colWidths = 50
            } else if (col === 4) {
              cellProperties.colWidths = 250
            } else if (col === 7) {
              cellProperties.colWidths = 30
            } else if (col === 16) {
              cellProperties.colWidths = 150
            } else if (col === 18) {
              cellProperties.colWidths = 55
            }

            return cellProperties
          },
          dropdownMenu: ['filter_by_value', 'filter_action_bar'],
          filters: true,
          headerTooltips: {
            columns: true,
            onlyTrimmed: true
          },
          hiddenColumns: {
            columns: [9, 10, 13, 14],
            indicators: true
          },
          collapsibleColumns: true
        }
      }
    },
    async mounted () {
      const params = new URLSearchParams()
      params.append('per_page', 200)
      params.append('timeslot_start', 'gte_now')

      params.append('organization_id', 6099) // Presidential Inaugural Committee
      params.append('organization_id', 9) // DNC
      params.append('organization_id', 612) // Arizona Dems
      params.append('organization_id', 2289) // California Dems
      params.append('organization_id', 207) // Florida Dems
      params.append('organization_id', 618) // Georgia Dems
      params.append('organization_id', 368) // NC Dems
      params.append('organization_id', 3510) // 2020 Victory

      params.append('organization_id', 4897) // AARP
      params.append('organization_id', 1847) // Fair Count
      params.append('organization_id', 5995) // ACLU KY
      params.append('organization_id', 6150) // Yang for NY

      await this.$store.dispatch('fetchMobilizeDataWithPreview', { params })

      this.hotRef = this.$refs.hotTableComponent.hotInstance
    },
    methods: {
    }
  }
</script>
<style>
    .menuable__content__active {
      z-index: 200!important
    }

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .switch label {
      color: white!important
    }
</style>
